import React, { useEffect } from 'react';

interface PageMetaProps {
  title: string;
  description?: string;
  keywords?: string;
  canonical?: string;
}

const PageMeta: React.FC<PageMetaProps> = ({
  title,
  description = "Café Tutoriales - Plataforma de aprendizaje con videos tutoriales",
  keywords = "tutoriales, aprendizaje, videos, café, cafe, educacion, tutorial",
  canonical
}) => {
  useEffect(() => {
    // Atualizar título da página
    document.title = title;

    // Meta tags básicas
    updateMetaTag('description', description);
    updateMetaTag('keywords', keywords);

    // Meta tags Open Graph para redes sociais
    updateMetaTag('og:title', title);
    updateMetaTag('og:description', description);
    updateMetaTag('og:type', 'website');

    // Meta tags Twitter
    updateMetaTag('twitter:title', title);
    updateMetaTag('twitter:description', description);

    // Canonical URL
    if (canonical) {
      const canonicalLink = document.querySelector('link[rel="canonical"]');
      if (canonicalLink) {
        canonicalLink.setAttribute('href', canonical);
      } else {
        const link = document.createElement('link');
        link.rel = 'canonical';
        link.href = canonical;
        document.head.appendChild(link);
      }
    }
  }, [title, description, keywords, canonical]);

  return null;
};

function updateMetaTag(name: string, content: string) {
  const selector = name.startsWith('og:') || name.startsWith('twitter:')
    ? `meta[property="${name}"]`
    : `meta[name="${name}"]`;

  let meta = document.querySelector(selector) as HTMLMetaElement;

  if (meta) {
    meta.content = content;
  } else {
    meta = document.createElement('meta');
    if (name.startsWith('og:') || name.startsWith('twitter:')) {
      meta.setAttribute('property', name);
    } else {
      meta.setAttribute('name', name);
    }
    meta.content = content;
    document.head.appendChild(meta);
  }
}

export default PageMeta;